export default "__VITE_ASSET__BMVd2FUT__"